"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFacets = void 0;
const react_1 = require("react");
const services_1 = require("../../services");
const types_1 = require("../../types");
const reducer_1 = __importStar(require("./reducer"));
class FacetsError extends Error {
    constructor(message) {
        super(message);
        this.name = 'FacetsError';
    }
}
const addReleases = (facets) => facets.map((facet) => {
    if (['departments.name', 'departamento-categoria'].includes(facet.field)) {
        return Object.assign(Object.assign({}, facet), { entries: [
                {
                    name: 'Lançamentos',
                    slugName: 'lancamento',
                    facet: null,
                },
                ...facet.entries,
            ] });
    }
    return facet;
});
const useFacets = ({ businessUnit, catalogSlug, uf }, enabled = true) => {
    const [state, dispatch] = (0, react_1.useReducer)(reducer_1.default, reducer_1.initialState);
    const fetchFacets = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!enabled)
                return;
            dispatch({ type: types_1.ApiActionTypeEnum.CALL_API });
            const { data } = yield (0, services_1.getFacets)({ businessUnit, catalogSlug, uf });
            const facets = addReleases(data.facets);
            dispatch({
                type: types_1.ApiActionTypeEnum.RESOLVED,
                payload: { facets },
            });
        }
        catch (err) {
            window.NREUM.noticeError(new FacetsError(`Failed to fetch facets: ${err instanceof Error ? err.message : 'Unknown error'}. CatalogSlug: ${catalogSlug}, BusinessUnit: ${businessUnit}`), {
                origin: 'MLD/Menu',
                brand: process.env.REACT_APP_CURRENT_BRAND,
                params: {
                    catalogSlug,
                    businessUnit,
                },
            });
            dispatch({
                type: types_1.ApiActionTypeEnum.REJECTED,
                error: err instanceof Error ? err.message : err,
            });
        }
    }), [enabled, businessUnit, catalogSlug, uf]);
    (0, react_1.useEffect)(() => {
        fetchFacets();
    }, [fetchFacets]);
    return (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, state), { idle: !state.loading && !state.error && !state.resolved })), [state]);
};
exports.useFacets = useFacets;
